/*
 * @Description: 国密
 * @Author: tanglitong
 * @CreationDate: 2023/3/29 16:46
 */

import smCrypto from 'sm-crypto'

/**
 * @description: sm2公钥加密
 * @return {*}
 * @param keyword 加密目标
 * @param publicKey 公钥
 * @param cipherMode 密码模式
 */
export const sm2Encrypt = (
  keyword,
  publicKey = process.env.WUE_APP_PUBLICKEY,
  cipherMode = 1
) => {
  const code = smCrypto.sm2.doEncrypt(keyword, publicKey, cipherMode);
  return `04${code}`;
};

/**
 * @description: sm3杂凑
 * @return {*}
 * @param keyword 加密目标
 */
export const sm3Encrypt = (keyword) => {
  return smCrypto.sm3(keyword);
};



// WEBPACK FOOTER //
// ./src/components/verifition/utils/sm-crypto.js